/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateProjectRequestBody,
  CreateProjectRequestBody$Outbound,
  CreateProjectRequestBody$outboundSchema,
} from "../components/createprojectrequestbody.js";

export type CreateProjectSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type CreateProjectRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  createProjectRequestBody: CreateProjectRequestBody;
};

/** @internal */
export type CreateProjectSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const CreateProjectSecurity$outboundSchema: z.ZodMiniType<
  CreateProjectSecurity$Outbound,
  CreateProjectSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function createProjectSecurityToJSON(
  createProjectSecurity: CreateProjectSecurity,
): string {
  return JSON.stringify(
    CreateProjectSecurity$outboundSchema.parse(createProjectSecurity),
  );
}

/** @internal */
export type CreateProjectRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  CreateProjectRequestBody: CreateProjectRequestBody$Outbound;
};

/** @internal */
export const CreateProjectRequest$outboundSchema: z.ZodMiniType<
  CreateProjectRequest$Outbound,
  CreateProjectRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    createProjectRequestBody: CreateProjectRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      createProjectRequestBody: "CreateProjectRequestBody",
    });
  }),
);

export function createProjectRequestToJSON(
  createProjectRequest: CreateProjectRequest,
): string {
  return JSON.stringify(
    CreateProjectRequest$outboundSchema.parse(createProjectRequest),
  );
}
